module.exports = __webpack_public_path__ + "static/img/one.d157471.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/index/one.jpeg
// module id = cVOk
// module chunks = 202